const tipos = [
  'Otros',
  'Hotel',
  'Aparthoteles',
  'Hostal',
  'Apartamento / Condominio',
  'Motel',
  'Casa de Huéspedes',
  'Hostal',
  'Complejo turístico',
  'Estancia en granja',
  'Alquiler vacacional',
  'Pensión',
  'Villa',
  'Cuarto',
]

export default tipos

// Arreglo Original Json
// {
//   "0": "Otros",
//   "1": "Hotel",
//   "2": "Aparthoteles",
//   "3": "Hostal",
//   "4": "Apartamento / Condominio",
//   "5": "Motel",
//   "6": "Casa de huéspedes",
//   "7": "Hostal",
//   "8": "Complejo turístico",
//   "9": "Estancia en granja",
//   "10": "Alquiler vacacional",
//   "11": "Pensión",
//   "12": "Villa",
//   "13": "Room"
// }
